import { useState, useEffect } from "react";

import axiosInstance from "../../../api/axios";

import DataTable from "../../table/DataTable";

import "../../../clients.css";

const columns = [
  { id: "id", label: "#" },
  { id: "name", label: "Cég" },
  { id: "code", label: "Telephely" },
  { id: "companyCreatedAt", label: "Létrehozás dátuma" },
  { id: "action", label: "Művelet" },
];

const Clients = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance
      .get("/api-admin/companies")
      .then((response) => {
        setData(response.data.result);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <DataTable
      dataList={data}
      createButtonLink={"/create-company"}
      createButtonText={"Új cég létrehozása"}
      editable={true}
      title={"Cég lista"}
      columns={columns}
      operationLink={"edit-company"}
      loading={loading}
    />
  );
};

export default Clients;
